import {
  Bold,
  Code,
  Heading1,
  Heading2,
  Heading3,
  Italic,
  Link,
  List,
  ListOrdered,
  ListTodo,
  TextQuote,
} from "lucide-react";
import { Button } from "@/components/ui-kit/button";
import { EditorCommands } from "./markdown-editor";
const tools = [
  {
    id: 1,
    name: "Heading",
    children: [
      {
        id: "h1",
        name: "H1",
        children: Heading1,
        onClick: (commands: EditorCommands) => commands.h1(),
      },
      {
        id: "h2",
        name: "H2",
        children: Heading2,
        onClick: (commands: EditorCommands) => commands.h2(),
      },
      {
        id: "h3",
        name: "H3",
        children: Heading3,
        onClick: (commands: EditorCommands) => commands.h3(),
      },
    ],
  },
  {
    id: 2,
    name: "Formatting",
    children: [
      {
        id: "bold",
        name: "Bold",
        children: Bold,
        onClick: (commands: EditorCommands) => commands.bold(),
      },
      {
        id: "italic",
        name: "Italic",
        children: Italic,
        onClick: (commands: EditorCommands) => commands.italic(),
      },
    ],
  },
  {
    id: 3,
    name: "Lists",
    children: [
      {
        id: "unordered-list",
        name: "Unordered List",
        children: List,
        onClick: (commands: EditorCommands) => commands.unordered(),
      },
      {
        id: "ordered-list",
        name: "Ordered List",
        children: ListOrdered,
        onClick: (commands: EditorCommands) => commands.ordered(),
      },
      {
        id: "task-list",
        name: "Task List",
        children: ListTodo,
        onClick: (commands: EditorCommands) => commands.task(),
      },
    ],
  },
  {
    id: 4,
    name: "Blocks",
    children: [
      {
        id: "quote",
        name: "Quote",
        children: TextQuote,
        onClick: (commands: EditorCommands) => commands.quote(),
      },
      {
        id: "code",
        name: "Code",
        children: Code,
        onClick: (commands: EditorCommands) => commands.code(),
      },
      {
        id: "link",
        name: "Link",
        children: Link,
        onClick: (commands: EditorCommands) => commands.link(),
      },
    ],
  },
];

type MarkdownEditorToolbarProps = {
  commands: EditorCommands;
  disabled?: boolean;
};

export const MarkdownEditorToolbar = ({ commands, disabled }: MarkdownEditorToolbarProps) => {
  return (
    <>
      {tools.map((group) => (
        <div key={group.id} className="flex">
          {group.children.map((tool) => {
            const Icon = tool.children;
            return (
              <Button
                type="button"
                key={tool.id}
                onClick={(e) => {
                  e.stopPropagation();
                  tool.onClick(commands);
                }}
                disabled={disabled}
                variant="outline"
                className="h-8 w-8 rounded-none border-r-0 p-0 first:rounded-l-sm last:rounded-r-sm last:border-r"
              >
                <Icon className="aspect-square w-4" />
              </Button>
            );
          })}
        </div>
      ))}
    </>
  );
};
